// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.runtime-shell {
  display: grid;
  gap: 1.5rem;
  padding: 0.5rem 0;
}
.runtime-shell header {
  padding: 1.25rem 1.5rem;
  background: #f4f7fa;
  border: 1px solid #dce4eb;
  border-left: 4px solid #0073e6;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem 1rem;
  flex-wrap: wrap;
}
.runtime-shell h1 {
  margin: 0;
  font-size: 1.6rem;
  line-height: 1.2;
  font-weight: 700;
  color: #1a2a38;
  letter-spacing: -0.01em;
}
.runtime-shell a {
  color: #0f6075;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9rem;
  line-height: 1.3;
  padding: 0.35rem 0.6rem;
  border: 1px solid #b8c9d5;
  border-radius: 4px;
  background: #fff;
}

.not-found {
  display: grid;
  gap: 0.75rem;
  padding: 0.5rem 0;
}
.not-found h1 {
  margin: 0;
  font-size: 1.45rem;
  line-height: 1.2;
}
.not-found a {
  color: #0f6075;
  text-decoration: none;
  font-weight: 600;
  width: fit-content;
  min-height: 2.5rem;
  display: inline-flex;
  align-items: center;
}

@media (max-width: 900px) {
  .runtime-shell header {
    flex-direction: column;
    align-items: stretch;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tools/dynamic-forms/dynamic-form-runtime-page/dynamic-form-runtime-page.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AACF;AACE;EACE,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AACJ;AAEE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AAAJ;AAGE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AADJ;;AAKA;EACE,aAAA;EACA,YAAA;EACA,iBAAA;AAFF;AAIE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;AAHJ;;AAOA;EACE;IACE,sBAAA;IACA,oBAAA;EAJF;AACF","sourcesContent":[".runtime-shell {\n  display: grid;\n  gap: 1.5rem;\n  padding: 0.5rem 0;\n\n  header {\n    padding: 1.25rem 1.5rem;\n    background: #f4f7fa;\n    border: 1px solid #dce4eb;\n    border-left: 4px solid #0073e6;\n    border-radius: 6px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 0.75rem 1rem;\n    flex-wrap: wrap;\n  }\n\n  h1 {\n    margin: 0;\n    font-size: 1.6rem;\n    line-height: 1.2;\n    font-weight: 700;\n    color: #1a2a38;\n    letter-spacing: -0.01em;\n  }\n\n  a {\n    color: #0f6075;\n    text-decoration: none;\n    font-weight: 600;\n    font-size: 0.9rem;\n    line-height: 1.3;\n    padding: 0.35rem 0.6rem;\n    border: 1px solid #b8c9d5;\n    border-radius: 4px;\n    background: #fff;\n  }\n}\n\n.not-found {\n  display: grid;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n\n  h1 {\n    margin: 0;\n    font-size: 1.45rem;\n    line-height: 1.2;\n  }\n\n  a {\n    color: #0f6075;\n    text-decoration: none;\n    font-weight: 600;\n    width: fit-content;\n    min-height: 2.5rem;\n    display: inline-flex;\n    align-items: center;\n  }\n}\n\n@media (max-width: 900px) {\n  .runtime-shell header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
